export const horizontalMargin = 80 * (window.devicePixelRatio || 1);
export const gatesDistance = 50 * (window.devicePixelRatio || 1);
export const controlRadius = 10 * (window.devicePixelRatio || 1);

export const dy = 35 * (window.devicePixelRatio || 1);

export const gateWidth = dy * 0.8;
export const gateHeight = dy * 0.8;

export const classicRegisterLineSidtance = 4 * (window.devicePixelRatio || 1);
export const strokeWidth = 1 * (window.devicePixelRatio || 1);

export const gateFontSize = 15 * (window.devicePixelRatio || 1);
